function checkToken(seconds: number) {
    const validTill = new Date(new Date().getTime() + seconds * 1000);
    const currentTime = new Date();
    return validTill > currentTime;
}

export default checkToken;
